import React, { type FC, useState } from "react";
import { useApiCall } from "../api/api";
import { Project } from "../api/dto";
import type { InspectionAttachment } from "../api/dto/InspectionAttachment";
import { Input } from "../components/form/Input";
import { ModalFooter } from "../components/layout/ModalProvider";

export const EditAttachmentName: FC<{
  attachment: InspectionAttachment;
  onFinished?: (attachment: InspectionAttachment) => void;
}> = (props) => {
  const { updateAttachment } = useApiCall();
  const [name, setName] = useState(props.attachment.name);

  const save = async () => {
    await updateAttachment(props.attachment.inspectionId, props.attachment.id, name);
    props.onFinished?.({ ...props.attachment, name: name });
  };
  return (
    <div>
      <Input type={"text"} label={"Toelichting"} value={name} onChange={setName} />
      <ModalFooter text={"Opslaan"} onSubmit={save} />
    </div>
  );
};
